import { useState } from 'react';
import { ProfessionalCard } from './ProfessionalCard';

interface ProfessionalsCarouselProps {
	professionals: Array<Professionals.Professional>;
}

const ProfessionalsCarousel = ({
	professionals,
}: ProfessionalsCarouselProps) => {
	const [currentIndex] = useState(0);
	const [selectedId, setSelectedId] = useState<string | null>(null);

	const getVisibleCards = () => {
		if (window.innerWidth < 768) {
			return professionals.length > 0
				? [professionals[currentIndex]]
				: [];
		}

		const cards = [];
		const totalCards = professionals?.length;

		if (!totalCards) return [];

		cards.push(professionals[currentIndex]);

		if (totalCards > 1) {
			const nextIndex = (currentIndex + 1) % totalCards;
			cards.push(professionals[nextIndex]);
		}

		if (totalCards > 2) {
			const nextNextIndex = (currentIndex + 2) % totalCards;
			cards.push(professionals[nextNextIndex]);
		}

		return cards;
	};

	return (
		<div className="relative mx-auto w-full max-w-6xl px-4">
			<div className="relative overflow-hidden">
				<div className="flex flex-col items-stretch justify-center gap-8 transition-transform duration-300 md:flex-row">
					{getVisibleCards()?.map((professional, index) => {
						const serviceName = (professional as any)
							.professional_services?.[0]?.service?.service_name;

						return (
							<ProfessionalCard
								key={`${professional?.id}-${index}`}
								name_prefix={(professional as any).name_prefix}
								first_name={professional.first_name}
								last_name={professional.last_name}
								profile_photo_url={
									professional.profile_photo_url
								}
								video_url={professional.video_url}
								crm_or_crp={professional.crm_or_crp}
								brief_description={
									professional.brief_description
								}
								service_name={serviceName}
								highlight_tag={professional.highlight_tag}
								main_approach={professional.main_approach}
								secondary_approaches={
									professional.secondary_approaches
								}
								focus_topics={professional.focus_topics}
								isSelected={selectedId === professional.id}
								onClick={() => setSelectedId(professional.id)}
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export { ProfessionalsCarousel };
